import { render, staticRenderFns } from "./ShareLandingOld.vue?vue&type=template&id=e885da3c&scoped=true"
import script from "./ShareLandingOld.vue?vue&type=script&lang=js"
export * from "./ShareLandingOld.vue?vue&type=script&lang=js"
import style0 from "./ShareLandingOld.vue?vue&type=style&index=0&id=e885da3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e885da3c",
  null
  
)

export default component.exports